module.exports = __webpack_public_path__ + "static/img/home-img-4.a099916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-img-4.png
// module id = 2sQl
// module chunks = 0